import urls from '../constants/urls'

import {
  checkIfErrorCodePresent,
  gatherErrors
} from '../utils/errorHandling'

export const INVITE_CREATE_FAILED = 'invites/INVITE_CREATE_FAILED'
export const INVITE_CREATE_FAILED_ALREADY_INVITED = 'invites/INVITE_CREATE_FAILED_ALREADY_INVITED'
export const INVITE_CREATE_SUCCESS = 'invites/INVITE_CREATE_SUCCESS'
export const CREATING_INVITE = 'invites/CREATING'
export const RESET_FORM = 'invites/RESET_FORM'

export const INVITE_DESTROY_FAILED = 'invites/DESTROY_FAILED'
export const INVITE_DESTROY_SUCCESS = 'invites/DESTROY_SUCCESS'
export const DESTROYING_INVITE = 'invites/DESTROYING'

export const INVITES_LOAD_FAILED = 'invites/LOAD_FAILED'
export const INVITES_LOAD_SUCCESS = 'invites/LOAD_SUCCESS'
export const LOADING_INVITES = 'invites/LOADING'

const initialState = {
  invites: [],

  createErrors: {},

  failedCreating:   false,
  failedDestroying: false,
  failedLoading:    false,

  hasLoaded: false,

  isCreating:   false,
  isDestroying: false,
  isLoading:    false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATING_INVITE:
      return {
        ...state,
        createErrors:   {},
        isCreating:     true,
        failedCreating: false
      }

    case INVITE_CREATE_SUCCESS:
      return {
        ...state,
        createErrors:     {},
        isCreating:       false
      }

    case INVITE_CREATE_FAILED:
      let errors = gatherErrors(action.error, 'invite_create_failed')

      return {
        ...state,
        createErrors:   errors,
        isCreating:     false,
        failedCreating: true
      }

    case DESTROYING_INVITE:
      return {
        ...state,
        isDestroying:     true,
        failedDestroying: false
      }

    case INVITE_DESTROY_SUCCESS:
      return {
        ...state,
        isDestroying: false
      }

    case INVITE_DESTROY_FAILED:
      return {
        ...state,
        isDestroying:     false,
        failedDestroying: true
      }

    case LOADING_INVITES:
      return {
        ...state,
        isLoading:     true,
        failedLoading: false
      }

    case INVITES_LOAD_SUCCESS:
      return {
        ...state,
        invites:       action.payload.data,
        pages:         action.payload.headers['x-pages'],
        page:          action.payload.headers['x-total'],
        total:         action.payload.headers['x-total'],
        isLoading:     false,
        failedLoading: false,
        hasLoaded:     true
      }

    case INVITES_LOAD_FAILED:
      return {
        ...state,
        isLoading:     false,
        failedLoading: true
      }

    default:
      return state
  }
}

export const loadInvites = (hospital, page, searchTerm) => (dispatch) => {
  return dispatch({
    types:   [LOADING_INVITES, INVITES_LOAD_SUCCESS, INVITES_LOAD_FAILED],
    payload: {
      request: {
        url:    urls.hospitals.invites.index(hospital.id),
        params: { page, search_string: searchTerm }
      }
    }
  })
}

export const createInvite = (hospitalId, params) => (dispatch) => {
  let onError = ({ error }) => {
    if (checkIfErrorCodePresent(error, 'user_already_invited')) {
      dispatch({ type: INVITE_CREATE_FAILED_ALREADY_INVITED })
    }
  }

  let action = {
    types:   [CREATING_INVITE, INVITE_CREATE_SUCCESS, INVITE_CREATE_FAILED],
    payload: {
      request: {
        method: 'post',
        url:    urls.hospitals.invites.create(hospitalId),
        data:   { user: params }
      }
    }
  }

  let promise = dispatch(action)

  promise.catch(onError)

  return promise
}

export const destroyInvite = (hospitalId, inviteId) => (dispatch) => {
  return dispatch({
    types:   [DESTROYING_INVITE, INVITE_DESTROY_SUCCESS, INVITE_DESTROY_FAILED],
    payload: {
      request: {
        method: 'delete',
        url:    urls.hospitals.invites.destroy(hospitalId, inviteId)
      }
    }
  })
}
